import { THESIS_BARO_DATA } from './thesisBaroData';

const THESIS_IDS = ['t2', 't1', 't3', 't4', 't5', 't6', 't9', 't7', 't8'];

function valueAt(series, targetT = 2.0) {
  const pts = series.filter(p => p.t <= targetT);
  return pts.length > 0 ? pts[pts.length - 1].v : 50;
}

function buildThesis(id) {
  const data = THESIS_BARO_DATA[id];
  if (!data) return null;
  const cohorts = data.cohorts.map(c => ({
    id:         c.id,
    color:      c.color,
    labelShort: c.labelShort,
    value:      valueAt(c.series),
  }));
  const vals = cohorts.map(c => c.value);
  const gap  = Math.max(...vals) - Math.min(...vals);
  return { id, cohorts, gap };
}

const ALL_THESES = THESIS_IDS.map(buildThesis).filter(Boolean);

export function getSortedTheses() {
  return [...ALL_THESES].sort((a, b) => b.gap - a.gap);
}

export function getLeadGap() {
  const sorted = getSortedTheses();
  return sorted.length > 0 ? Math.round(sorted[0].gap) : 0;
}
